import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import UserForm from './UserForm';


class NewUserModal  extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    submit = ( values ) => {
        this.setState( { fetching: true } );

        var user = { ...values };
        var updates = { affil: [] };

        //parse out subaffiliate ids for updating independentaly
        if( user.amazonsubaffiliateid ) {
            updates.affil.push( {
                affiliateid: 1,
                subAffiliateCode: user.amazonsubaffiliateid || null,
            } );
            delete user.amazonsubaffiliateid;
        }

        if( user.commisionsubaffiliateid ) {
            updates.affil.push( {
                affiliateid: 2,
                subAffiliateCode: user.commisionsubaffiliateid || null,
            } );
            delete user.commisionsubaffiliateid;
        }

        if( user.rakutensubaffiliateid ) {
            updates.affil.push( {
                affiliateid: 3,
                subAffiliateCode: user.rakutensubaffiliateid || null,
            } );
            delete user.rakutensubaffiliateid;
        }

        if( user.targetSubaffiliateId ) {
            updates.affil.push( {
                affiliateid: 4,
                subAffiliateCode: user.targetSubaffiliateId || null,
            } );
            delete user.targetSubaffiliateId;
        }

        delete user.affiliateCodes;

        updates.data = {
            signUpType: 'Email',
            user: user,
        };

        return Promise.resolve( this.props.onSubmit && this.props.onSubmit( updates ) )
        .then( () => {
            this.setState( { fetching: false } );
            this.props.closeModal();
        } )
        .catch( (e) => {
            alert('Please verify the email and/or slug is not already use and there is a password.');
            this.setState( { fetching: false } );
        });
    }



    render() {
        const { modalName, modalProps } = this.props;
        let goodToGo = false;
        if ( modalName === 'newUserModal' ) {
            goodToGo = true;
        }
        var initialValues = {
            'emailAddress': null,
            'deactivated': null,
            'displayName': null,
            'slug': null,
            'usertype': 'shopper',
            'verified': null,
            'avatar': null,
            'website': null,
            'description': null,
            'facebook': null,
            'twitter': null,
            'instagram': null,
            'interests': [],
            'categories': [],
        };
        return (
            <ReactModal
            isOpen={ modalProps.modalIsOpen && goodToGo }
            contentLabel="Edit User"
            onRequestClose={ this.props.closeModal }
            className='modal-popup'
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>New User</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div>
                    <UserForm
                    submitHandler={ this.submit }
                    initialValues={ initialValues }
                    password />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};

export default connect( mapStateToProps )( NewUserModal );
